import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awaiting-contact',
  templateUrl: './awaiting-contact.component.html',
  styleUrls: ['./awaiting-contact.component.scss']
})
export class AwaitingContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
